import React, { Component } from 'react';
import Job from './Job';
import { Droppable } from 'react-beautiful-dnd';

export default class DateJobsList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="order-jobs-holder">
                <Droppable droppableId={this.props.id.toString()}>
                    {(provided) => (
                        <div className="table-container" {...provided.droppableProps} ref={provided.innerRef}>
                            <div className="flex-table header transform-text">
                                <div className="flex-row">Select</div>
                                <div className="flex-row">Date Created</div>
                                <div className="flex-row">Date Ready</div>
                                <div className="flex-row">Special Requests</div>
                                <div className="flex-row">Site Address</div>
                                <div className="flex-row">Job Number</div>
                                <div className="flex-row">Type of Job</div>
                                <div className="flex-row">Customer Name</div>
                                <div className="flex-row">Actions</div>
                                <div className="flex-row">Assign</div>
                            </div>
                            {typeof this.props.jobs !== 'undefined' && this.props.jobs.length > 0 ? (
                                this.props.jobs.map((job, index) => {
                                    if (job.execution_date === moment(this.props.selectedDate).format('YYYY-MM-DD')) {
                                        return (
                                            <Job
                                                key={job.id}
                                                index={index}
                                                job={job}
                                                memberId={this.props.id}
                                                onClick={this.props.onClick}
                                                showModal={this.props.showModal}
                                                onJobSelect={this.props.onJobSelect}
                                                isSelected={this.props.selectedJobs.includes(job.id)}
                                                members={this.props.members}
                                                quickAssign={this.props.quickAssign}
                                                updateSpecialRequests={this.props.updateSpecialRequests}
                                            />
                                        );
                                    }
                                })
                            ) : (
                                <p className="text-center mt-2">No jobs allocated</p>
                            )}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
